import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: {
        translation: require('../src/translate/de.json'),
      },
      en: {
        translation: require('../src/translate/en.json'),
      },
    },
    fallbackLng: 'de', 
    debug: false,
    // detection: {
    //   order: [
    //     'querystring',
    //     'cookie',
    //     'localStorage',
    //     'navigator',
    //     'htmlTag',
    //     'path',
    //     'subdomain',
    //   ],
    //   caches: ['cookie', 'localStorage'],
    // },
    // interpolation: {
    //   escapeValue: false,
    // },
  });
export default i18n;
